import I18n from 'I18n';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import ManageAccessDescription from 'email-management-lib/refactor/components/ManageAccessDescription';
import useManageAccessPanel from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useManageAccessPanel';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useMemo } from 'react';
import UsersAndTeamsAssetAccessPanel from 'ui-asset-management-lib/components/UsersAndTeamsAssetAccessPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManageAccessPanel({
  crmObjects,
  isAssigningAllInCurrentView,
  hasManageAccessScope,
  onClose,
  onSuccess,
  totalObjects
}) {
  const objectIds = useMemo(() => {
    return crmObjects.map(crmObject => typeof crmObject.objectId === 'string' ? parseInt(crmObject.objectId, 10) : crmObject.objectId);
  }, [crmObjects]);
  const contentIds = crmObjects.map(crmObject => Number(getPropertyValue(crmObject, PROPERTIES.MARKETING_EMAIL_ID)));
  const {
    teamIds,
    userIds,
    hasErrors,
    isLoading,
    handleSave,
    users,
    teams
  } = useManageAccessPanel({
    isAssigningAllInCurrentView,
    contentIds,
    objectIds,
    onClose,
    onSuccess,
    totalObjects
  });
  return (
    /*#__PURE__*/
    // @ts-expect-error Type 'import("framework-asset-management-lib@1.13933/js/types").User[]' is not assignable to type 'import("ui-asset-management-lib@1.3308/js/records/User").default[]'.
    _jsx(UsersAndTeamsAssetAccessPanel, {
      assetTypeDisplayName: I18n.text('email-management.assignTeams.assetTypeDisplayName'),
      assignedTeamIds: teamIds,
      assignedUserIds: userIds,
      description: /*#__PURE__*/_jsx(ManageAccessDescription, {}),
      onCancel: onClose,
      onSave: handleSave,
      requestsError: hasErrors,
      requestsLoading: isLoading,
      teams: teams,
      useAccessLanguage: true,
      userHasTeamAssignmentScope: hasManageAccessScope,
      users: users
    })
  );
}